import React from "react";
import UseContext from "hooks/useContext";

// Perimeter of a list row: its name, flagged when archived, or "None" greyed.
const PerimeterName = ({ perimeter }) => {
    const { language } = UseContext();

    if (!perimeter) {
        return (
            <span className="text-gray-400">
                {language.getValue("perimeters.missionDetail.none")}
            </span>
        );
    }

    return (
        <span title={perimeter.name}>
            {perimeter.name}
            {perimeter.archived && (
                <span className="ml-1 text-gray-400">
                    {language.getValue("perimeters.missionDetail.archived")}
                </span>
            )}
        </span>
    );
};

export default PerimeterName;
